(function () {
    'use strict';

    angular.module("imApp").factory("bspUgService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3159,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3160,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
